// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2VYAj","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2mwpd","obliqueLine":"membershipbadge_obliqueLine__2TvwX"};